export const translationsFr = {
    "message1" : "Bonjour en français",
    "home.watch.the.film":"Voir le film",
    'home.raison.etre': "Découvrir notre raison d'être",
    'close': 'Fermer'
}